// extracted by mini-css-extract-plugin
export default {"noTerminalMsgHeader":"TerminalList_noTerminalMsgHeader__xgAb2","noTerminalSubText":"TerminalList_noTerminalSubText__w-ygP"};